import React from 'react';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import toDollars from 'utils/to-dollars';

import { EntityId } from 'services/entities/types';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { AppState } from 'services/types';
import { TIMESHEET_HOLIDAYS_MULTIPLIER } from 'services/timesheetHolidays/constants';
// @ts-ignore
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';

// Components
import TimesheetHolidayIcon from 'components/TimesheetHolidayIcon';
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import TableCellTag from 'components/TableCellTag';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import TwelveHourTime from 'components/TwelveHourTime';
// @ts-ignore
import WorkTypeName from 'components/WorkTypeName';
// @ts-ignore
import IsApprovedStatusIcon from '../../../../../../components/IsApprovedStatusIcon';
import SelectedTableCellRowCheckbox from '../../../../../../components/SelectedTableCellRowCheckbox';
// @ts-ignore
import HourlyRateEntryExistsGate from '../HourlyRateEntryExistsGate';
// @ts-ignore
import PieceRateEntryExistsGate from '../PieceRateEntryExistsGate';
import LunchBreakTableCellRenderDropdown from './components/LunchBreakTableCellRenderDropdown';
// @ts-ignore
import EndTimeTableCellRenderDropdown from './components/EndTimeTableCellRenderDropdown';
// @ts-ignore
import FormTimesheetEntryValue from './components/FormTimesheetEntryValue';
// @ts-ignore
import SelectableTableCell from './components/SelectableTableCell';
// @ts-ignore
import StartTimeTableCellRenderDropdown from './components/StartTimeTableCellRenderDropdown';
// @ts-ignore
import TableCellRenderDatePicker from './components/TableCellRenderDatePicker';
// @ts-ignore
import TableCellRenderField from './components/TableCellRenderField';
import TimesheetEntriesTableRowWrapper from './components/TimesheetEntriesTableRowWrapper';
// @ts-ignore
import TimesheetEntryMoreDropdown from './components/TimesheetEntryMoreDropdown';
// @ts-ignore
import WorkTypeTableCellRenderDropdown from './components/WorkTypeTableCellRenderDropdown';
import PaidBreakTableCellRenderDropdown from './components/PaidBreakTableCellRenderDropdown';
import PersonFullNameFieldValue from './components/PersonFullNameFieldValue';
import EntityFieldValue from './components/EntityFieldValue';
import { makeSelectEntityId } from './selectors';
import { TOTAL_PAID_HOURS, TOTAL_PIECE_RATE_HOURS } from './components/FormTimesheetEntryValue/constants';

interface OwnProps {
    rowId: number;
}

interface ConnectedProps {
    entityId?: EntityId;
    date: TimesheetHolidayDate;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetEntriesTableRowComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { rowId, entityId, date } = this.props;

        return (
            <TimesheetEntriesTableRowWrapper
                rowId={rowId}
                timesheetEntryUuid={rowId}
            >
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <React.Fragment>
                        <Table.Cell
                            collapsing
                            style={{
                                lineHeight: 0
                            }}
                        >
                            <SelectedTableCellRowCheckbox rowId={rowId} />
                        </Table.Cell>
                        <Table.Cell
                            collapsing
                            style={{
                                padding: 0
                            }}
                        >
                            <TimesheetEntryMoreDropdown rowId={rowId} />
                        </Table.Cell>
                    </React.Fragment>
                </RoleGate>

                <SelectableTableCell
                    rowId={rowId}
                    cellName="date"
                    component={TableCellRenderDatePicker}
                >
                    {(value: string): React.ReactElement => (
                        <TimesheetHolidayGate
                            timesheetDate={date}
                            timesheetEntityId={entityId}
                            fallback={moment(value).format('DD/MM/YYYY')}
                        >
                            <div style={{ display: 'flex' }}>
                                {moment(date, 'YYYY-MM-DD').format(
                                    'DD/MM/YYYY'
                                )}
                                <TimesheetHolidayIcon
                                    timesheetDate={date}
                                    timesheetEntityId={entityId}
                                />
                            </div>
                        </TimesheetHolidayGate>
                    )}
                </SelectableTableCell>

                <Table.Cell active>
                    <PersonFullNameFieldValue rowId={rowId} />
                </Table.Cell>

                <SelectableTableCell
                    rowId={rowId}
                    cellName="workTypeCompositeKey"
                    component={WorkTypeTableCellRenderDropdown}
                >
                    {(workTypeCompositeKey: any): React.ReactElement => {
                        const [workTypeIdString]: any = workTypeCompositeKey
                            ? workTypeCompositeKey.split('.')
                            : [];
                        const workTypeId = Number(workTypeIdString);
                        return <WorkTypeName workTypeId={workTypeId} />;
                    }}
                </SelectableTableCell>

                <EntityFieldValue rowId={rowId} />

                <SelectableTableCell
                    rowId={rowId}
                    cellName="startTime"
                    component={StartTimeTableCellRenderDropdown}
                >
                    {(value: any): React.ReactElement => (
                        <TwelveHourTime value={value} />
                    )}
                </SelectableTableCell>

                <SelectableTableCell
                    rowId={rowId}
                    cellName="endTime"
                    component={EndTimeTableCellRenderDropdown}
                >
                    {(value: any): React.ReactElement => (
                        <TwelveHourTime value={value} />
                    )}
                </SelectableTableCell>

                <SelectableTableCell
                    rowId={rowId}
                    cellName="unpaidBreakMinutes"
                    component={LunchBreakTableCellRenderDropdown}
                />

                <HourlyRateEntryExistsGate>
                    <Table.Cell active>
                        <FormTimesheetEntryValue
                            rowId={rowId}
                            cellName={TOTAL_PAID_HOURS}
                        />
                    </Table.Cell>
                </HourlyRateEntryExistsGate>
                <SelectableTableCell
                    rowId={rowId}
                    cellName="units"
                    component={TableCellRenderField}
                />
                <PieceRateEntryExistsGate>
                    <SelectableTableCell
                        rowId={rowId}
                        cellName="rate"
                        component={TableCellRenderField}
                        isPieceRateField
                    >
                        {(value: any): React.ReactElement => (
                            <TimesheetHolidayGate
                                timesheetDate={date}
                                timesheetEntityId={entityId}
                                fallback={toDollars(value)}
                            >
                                <React.Fragment>
                                    {toDollars(value)}
                                    <TableCellTag>
                                        {` x${TIMESHEET_HOLIDAYS_MULTIPLIER} = ${toDollars(
                                            value *
                                                TIMESHEET_HOLIDAYS_MULTIPLIER
                                        )}`}
                                    </TableCellTag>
                                </React.Fragment>
                            </TimesheetHolidayGate>
                        )}
                    </SelectableTableCell>
                    <SelectableTableCell
                        rowId={rowId}
                        cellName="paidBreakMinutes"
                        component={PaidBreakTableCellRenderDropdown}
                        isPieceRateField
                    />
                    <Table.Cell active>
                        <FormTimesheetEntryValue
                            rowId={rowId}
                            cellName={TOTAL_PIECE_RATE_HOURS}
                        />
                    </Table.Cell>
                    <Table.Cell active>
                        <FormTimesheetEntryValue
                            rowId={rowId}
                            cellName="earnings"
                        >
                            {(value: any): React.ReactElement => (
                                <TimesheetHolidayGate
                                    timesheetDate={date}
                                    timesheetEntityId={entityId}
                                    fallback={toDollars(value)}
                                >
                                    {toDollars(
                                        value * TIMESHEET_HOLIDAYS_MULTIPLIER
                                    )}
                                </TimesheetHolidayGate>
                            )}
                        </FormTimesheetEntryValue>
                    </Table.Cell>
                    <Table.Cell active>
                        <FormTimesheetEntryValue
                            rowId={rowId}
                            cellName="effectiveRate"
                        >
                            {(value: any): React.ReactElement => (
                                <TimesheetHolidayGate
                                    timesheetDate={date}
                                    timesheetEntityId={entityId}
                                    fallback={toDollars(value)}
                                >
                                    {toDollars(
                                        value * TIMESHEET_HOLIDAYS_MULTIPLIER
                                    )}
                                </TimesheetHolidayGate>
                            )}
                        </FormTimesheetEntryValue>
                    </Table.Cell>
                    <Table.Cell active>
                        <FormTimesheetEntryValue
                            rowId={rowId}
                            cellName="paidBreakDollars"
                        >
                            {(value: any): React.ReactElement => (
                                <TimesheetHolidayGate
                                    timesheetDate={date}
                                    timesheetEntityId={entityId}
                                    fallback={toDollars(value)}
                                >
                                    {toDollars(
                                        value * TIMESHEET_HOLIDAYS_MULTIPLIER
                                    )}
                                </TimesheetHolidayGate>
                            )}
                        </FormTimesheetEntryValue>
                    </Table.Cell>
                </PieceRateEntryExistsGate>

                <Table.Cell collapsing active>
                    <FormTimesheetEntryValue
                        rowId={rowId}
                        cellName="lastReviewIsApproved"
                    >
                        {(value: any): React.ReactElement => (
                            <IsApprovedStatusIcon isApproved={value} />
                        )}
                    </FormTimesheetEntryValue>
                </Table.Cell>
            </TimesheetEntriesTableRowWrapper>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectEntityId(),
    date: makeSelectValuesTimesheetEntryValue('date')
});

export default connect(mapStateToProps)(TimesheetEntriesTableRowComponent);
